module.exports = __webpack_public_path__ + "h5/img/dingdan@3x.2970fc45.png";